import React from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { FileText, Trash2 } from "lucide-react";
import moment from "moment";

interface DraftRestoredBannerProps {
  draftTimestamp: string | null;
  onClearDraft: () => void;
}

export const DraftRestoredBanner: React.FC<DraftRestoredBannerProps> = ({
  draftTimestamp,
  onClearDraft,
}) => {
  return (
    <div className="p-3.5 bg-amber-50 border border-amber-200 rounded-xl flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-amber-900 shadow-2xs">
      {/* Left: Info */}
      <div className="flex items-center gap-2.5">
        <div className="p-1.5 bg-amber-100 rounded-lg text-amber-700">
          <FileText className="w-4 h-4" />
        </div>
        <div>
          <p className="font-bold text-amber-900">Unsaved Local Draft Restored</p>
          <p className="text-amber-700 text-[11px]">
            Your previous salary modifications from{" "}
            <span className="font-semibold">
              {draftTimestamp
                ? moment(draftTimestamp).format("DD MMM YYYY, hh:mm A")
                : "earlier session"}
            </span>{" "}
            are safely restored.
          </p>
        </div>
      </div>

      {/* Right: Actions */}
      <div className="flex items-center gap-2 self-end sm:self-auto">
        <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-100 border border-amber-300 font-semibold px-2.5 py-1 text-[11px]">
          Draft Auto-Saved
        </Badge>
        <Button
          variant="outline"
          size="sm"
          onClick={onClearDraft}
          className="h-8 text-xs bg-white border-amber-300 hover:bg-amber-100 text-amber-800 font-semibold gap-1.5 shadow-2xs"
        >
          <Trash2 className="w-3.5 h-3.5 text-rose-500" />
          Clear Draft & Reset
        </Button>
      </div>
    </div>
  );
};
